import { render, staticRenderFns } from "./CurrentSchedule.vue?vue&type=template&id=29b5d2ca&"
import script from "./CurrentSchedule.vue?vue&type=script&lang=js&"
export * from "./CurrentSchedule.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/sapphire/K12Live16/build/CommunityWebPortal/_app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('29b5d2ca')) {
      api.createRecord('29b5d2ca', component.options)
    } else {
      api.reload('29b5d2ca', component.options)
    }
    module.hot.accept("./CurrentSchedule.vue?vue&type=template&id=29b5d2ca&", function () {
      api.rerender('29b5d2ca', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/assets/js/components/CurrentSchedule/CurrentSchedule.vue"
export default component.exports